// src/routes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login/Login';
import Home from './pages/Home/Home';
import Roles from './pages/Roles/Roles';
import Orders from './pages/Orders/Orders';
import OrderDetail from './pages/Orders/OrderDetail';
import ProtectedRoute from './components/ProtectedRoute';
import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import ProductsList from './pages/Products/ProductList';
import ModifiersPage from './pages/Products/Modifiers';
import ScreensPage from './pages/Screens/Screens';
import Organizations from './pages/Organizations/Organizations';
import OneOrganization from './pages/Organizations/OneOrganization';
import CourierMonitor from './pages/CourierMonitor/CourierMonitor';




export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes (no sidebar) */}
      <Route element={<PublicLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/screens/:screenId" element={<ScreensPage/>} />
        <Route path="/courier-monitor/:organizationId" element={<CourierMonitor/>} />

        {/* add any other public routes here */}
      </Route>

      {/* Private routes (with sidebar) */}
      <Route
        element={
          // If you’re using a ProtectedRoute to ensure user is logged in
          <ProtectedRoute>
            <PrivateLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/home" element={<Home />} />
        <Route path="/roles" element={<Roles />} />
        <Route path='/orders' element={<Orders />} />
        <Route path='/orders/:orderId' element={<OrderDetail />} />
        <Route path="/products" element={<ProductsList />}/>
        <Route path="/modifiers/:productId" element={<ModifiersPage />} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/organizations/:organizationId" element={<OneOrganization />} />


        {/* <Route path="/orders" element={<Orders />} /> */}
        {/* more private pages... */}
      </Route>

      {/* Fallback: if no route matches, go to /login */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
}
